import { render, staticRenderFns } from "./BarNav.vue?vue&type=template&id=5ccb7067&scoped=true"
import script from "./BarNav.vue?vue&type=script&lang=js"
export * from "./BarNav.vue?vue&type=script&lang=js"
import style0 from "./BarNav.vue?vue&type=style&index=0&id=5ccb7067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccb7067",
  null
  
)

export default component.exports